import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../Footer/Footer";

export default function AboutPage() {
	return (
		<>
			<Navbar  />
			<div className="md:mt-[100px] mt-[130px] h-fit bg-gray-50 py-12 px-4 sm:px-8 lg:px-20">
				<div className="max-w-5xl mx-auto text-center">
					{/* About Section */}
					<h1 className="text-3xl sm:text-4xl font-extrabold mb-4 text-pink-600 font-americana">
						About Monsini
					</h1>
					<p className="text-gray-600 max-w-3xl mx-auto mb-10 text-sm sm:text-base leading-relaxed text-justify">
						With over 40 years of combined business experience, outstanding
						customer service, and knowledgeable sales staff,{" "}
						<span className="font-semibold">Monsini</span> always offers you the
						most fashion-forward gowns along with the traditional, exquisite
						styles for all of your occasions.
						<br />
						<br />
						We are excited to be part of your most memorable event — whether it
						is a special occasion or your exciting prom party. We have a
						magnitude of gowns to ensure you will look amazing on your special
						day.
						<br />
						<br />
						With a large network of retailers, we can assure you will find our
						gowns at a location near you. We promise you on-time delivery and
						outstanding customer service at any of our retail partner’s
						locations.
						<br />
						<br />
						Welcome to the most dramatic collection of Prom, Pageant, and Party
						dresses! Our mission is to provide the ultimate in fashion, fit, and
						service.
						<br />
						<br />
						Monsini offers the highest level of quality and design in all of our
						gowns, with a fit that makes every woman look and feel beautiful.
						Dramatic ballgowns, printed florals, oversized ruffles, crystal
						embellishments, cutout backs, strappy-trim, cutout skirts, oversize
						watercolors, beaded matte-jersey, and sexy shorts — every detail is
						crafted to make heads turn!
						<br />
						<br />
						We are proud to offer the best and most comprehensive services in
						the industry.
						<br />
						<br />
						<span className="font-semibold">
							Fashion… Value… Quality… Sizing… Selection!
						</span>
					</p>

					{/* Stats Section */}
					<div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12">
						<div className="bg-white shadow rounded-xl p-6 ">
							<h2 className="text-3xl font-bold text-pink-600">40+</h2>
							<p className="text-gray-600 text-sm">Years of Experience</p>
						</div>
						<div className="bg-white shadow rounded-xl p-6">
							<h2 className="text-3xl font-bold text-pink-600">500+</h2>
							<p className="text-gray-600 text-sm">Exclusive Gown Styles</p>
						</div>
						<div className="bg-white shadow rounded-xl p-6">
							<h2 className="text-3xl font-bold text-pink-600">Canadian</h2>
							<p className="text-gray-600 text-sm">Retail Network</p>
						</div>
					</div>

					{/* FAQ Section */}
					<div className="text-left max-w-3xl mx-auto">
						<h2 className="text-2xl sm:text-3xl font-semibold mb-6 text-center">
							Frequently Asked Questions
						</h2>

						<div className="mb-6">
							<h3 className="font-semibold text-gray-800 text-base sm:text-lg">
								What makes Monsini gowns unique?
							</h3>
							<p className="text-gray-600 text-sm sm:text-base">
								Each Monsini gown is designed with exceptional craftsmanship,
								luxurious fabrics, and attention to detail — ensuring a
								timeless, elegant fit for every woman.
							</p>
						</div>

						<div className="mb-6">
							<h3 className="font-semibold text-gray-800 text-base sm:text-lg">
								Where can I find Monsini dresses?
							</h3>
							<p className="text-gray-600 text-sm sm:text-base">
								Monsini gowns are available through our trusted network of
								retailers worldwide, offering easy accessibility and reliable
								service.
							</p>
						</div>

						<div>
							<h3 className="font-semibold text-gray-800 text-base sm:text-lg">
								Do you offer custom sizing or designs?
							</h3>
							<p className="text-gray-600 text-sm sm:text-base">
								We provide a wide range of sizes and designs, and our team is
								dedicated to helping you find the perfect gown that fits both
								your style and occasion.
							</p>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}
